import { Component, Input, Output, EventEmitter, signal, WritableSignal } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-button-group',
  template:`
    <div class="inline-flex rounded-lg bg-white dark:bg-background border border-gray-300 dark:border-slate-700/70 overflow-hidden divide-x dark:divide-slate-950 font-medium dark:bg-background" role="group">
    @for (label of labels(); track label.title; let i = $index; let last = $last; let first = $first) {
      <button [attr.data-cy]="label.active ? 'active' : 'inactive'"
        type="button"
        [ngClass]="{
          'bg-soft-blue dark:shadow-none dark:bg-black/30 shadow-inner text-black dark:text-white': label.active,
          'text-black/60 dark:text-white/60': !label.active
        }"
        class="break-normal whitespace-nowrap active flex-1 px-3.5 py-2 h-full flex items-center justify-center text-sm gap-3 hover:bg-soft-blue dark:hover:bg-slate-700"
        (click)="onButtonClick(label.title)">
        {{ label.title | titlecase }}
      </button>
    }
  </div>
  `,
  imports: [CommonModule, TitleCasePipe]
})
export class ButtonGroupComponent {
  @Input({required: true}) set buttonLabels(value: {title: string, active: boolean}[]) {
    this.labels.set(this.transformButtonLabels(value));
  }
  labels: WritableSignal<{title: string, active: boolean}[]> = signal([]);
  @Output() buttonClick = new EventEmitter<string>();

  onButtonClick(label: string): void {
    this.buttonClick.emit(label);
  }

  transformButtonLabels(value: {title: string, active: boolean}[]): {title: string, active: boolean}[] {
    return value.map(label => ({
      title: label.title,
      active: label.active
    }));
  }
} 